import React from 'react';
import LegalPage from '../components/LegalPage';

export default function TermsPage() {
  return (
    <LegalPage title="Terms of Service">
      <h2>1. Acceptance of Terms</h2>
      <p>By accessing or using LottoPickle ("the Service"), operated at lottopickle.com, you agree to be bound by these Terms of Service. If you do not agree, do not use the Service.</p>

      <h2>2. Description of Service</h2>
      <p>LottoPickle is a data analysis and visualization platform that displays historical lottery draw data from publicly available sources. The Service provides statistical tools including frequency analysis, heatmaps, trend charts, distribution analysis, number pair co-occurrence, gap analysis, and number generation.</p>

      <h2>3. Not Gambling Advice</h2>
      <p>The Service is provided for entertainment and educational purposes only. LottoPickle does not sell lottery tickets, facilitate gambling, or guarantee any outcomes. Historical frequency data has no mathematical bearing on future lottery draw results. Lottery draws are random events. Nothing on this site constitutes gambling advice or a promise of winnings.</p>

      <h2>4. Subscriptions and Payments</h2>
      <ul>
        <li>Some features require a paid subscription ("LottoPickle Premium"). Payments are processed securely by Stripe.</li>
        <li>Subscriptions auto-renew at the end of each billing period unless cancelled before renewal.</li>
        <li>You may cancel at any time through your account settings. Cancellation takes effect at the end of the current billing period.</li>
        <li>Refunds are governed by our <a href="/refunds">Refund Policy</a>.</li>
      </ul>

      <h2>5. User Accounts</h2>
      <p>You may use the Service with an anonymous account. If you provide an email address for newsletter subscription, you consent to receiving periodic emails. You may unsubscribe at any time.</p>

      <h2>6. Acceptable Use</h2>
      <p>You agree not to:</p>
      <ul>
        <li>Use the Service for any unlawful purpose</li>
        <li>Attempt to reverse-engineer, scrape, or programmatically access the Service beyond its intended use</li>
        <li>Interfere with the operation of the Service or its infrastructure</li>
        <li>Misrepresent the Service's analysis as guaranteed predictions or gambling advice</li>
      </ul>

      <h2>7. Intellectual Property</h2>
      <p>The Service's design, code, visualizations, and branding are the property of LottoPickle. Lottery draw data is sourced from publicly available government databases and is not proprietary to LottoPickle.</p>

      <h2>8. Data Sources</h2>
      <p>Historical lottery data is sourced from the New York State government open data portal. While we make reasonable efforts to ensure accuracy, LottoPickle does not guarantee the completeness or accuracy of third-party data. LottoPickle is not affiliated with any official lottery organization.</p>

      <h2>9. Disclaimer of Warranties</h2>
      <p>The Service is provided "as is" and "as available" without warranties of any kind, express or implied, including but not limited to merchantability, fitness for a particular purpose, or non-infringement.</p>

      <h2>10. Limitation of Liability</h2>
      <p>To the maximum extent permitted by law, LottoPickle and its operators shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of the Service, including but not limited to financial losses from lottery play.</p>

      <h2>11. Changes to Terms</h2>
      <p>We reserve the right to modify these Terms at any time. Changes take effect upon posting to this page. Continued use of the Service constitutes acceptance of updated Terms.</p>

      <h2>12. Contact</h2>
      <p>For questions about these Terms, contact us at <a href="mailto:info@lottopickle.com">info@lottopickle.com</a>.</p>
    </LegalPage>
  );
}
